import React from 'react';
import PropTypes from 'prop-types';

import BWStatusBadge from '../BWStatusBadge';
import { PortalIcon } from 'utils/baochauTheme';

const BWModalHeader = React.forwardRef(
  (
    {
      title,
      description,
      status,
      headerExtra,
      closable,
      closeDisabled,
      onClose,
      titleId,
      descriptionId,
      headerStyle,
      titleStyle,
      closeStyle,
    },
    ref,
  ) => (
    <header className='bw_modal_ds_header' style={headerStyle}>
      <div className='bw_modal_ds_heading'>
        <div className='bw_modal_ds_title_row'>
          <h2 id={titleId} ref={ref} tabIndex={-1} style={titleStyle}>
            {title}
          </h2>
          {status ? (
            React.isValidElement(status) ? (
              status
            ) : (
              <BWStatusBadge tone={status.variant || status.tone || 'neutral'}>{status.label}</BWStatusBadge>
            )
          ) : null}
        </div>
        {description ? (
          <p id={descriptionId} className='bw_modal_ds_description'>
            {description}
          </p>
        ) : null}
      </div>
      {headerExtra ? <div className='bw_modal_ds_header_extra'>{headerExtra}</div> : null}
      {closable ? (
        <button
          type='button'
          className='bw_modal_ds_close'
          aria-label='Đóng cửa sổ'
          title='Đóng'
          disabled={closeDisabled}
          onClick={onClose}
          style={closeStyle}>
          <PortalIcon icon='fi fi-rr-cross-small' aria-hidden='true' />
        </button>
      ) : null}
    </header>
  ),
);

BWModalHeader.displayName = 'BWModalHeader';

BWModalHeader.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  status: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      variant: PropTypes.oneOf(['neutral', 'info', 'success', 'warning', 'danger']),
      tone: PropTypes.oneOf(['neutral', 'info', 'success', 'warning', 'danger']),
    }),
  ]),
  headerExtra: PropTypes.node,
  closable: PropTypes.bool,
  closeDisabled: PropTypes.bool,
  onClose: PropTypes.func,
  titleId: PropTypes.string.isRequired,
  descriptionId: PropTypes.string,
  headerStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  closeStyle: PropTypes.object,
};

export default BWModalHeader;
